export default __webpack_public_path__ + "static/media/zeppelin.81e38647.png";